import { createIsomorphicFn } from '@tanstack/react-start'
import { getRequestHeader } from '@tanstack/react-start/server'

/**
 * The host the visitor asked for: the Host header on the server, the address bar in the browser.
 * Outside a request (unit tests, prerender without a request) there is no host: the answer is ''.
 */
export const requestHost = createIsomorphicFn()
  .server(() => {
    try {
      return getRequestHeader('host') ?? ''
    } catch {
      return ''
    }
  })
  .client(() => window.location.host)
